import { mapEnumToOptions } from '@abp/ng.core';

export enum DisplayType {
  Standard = "Standard",
  ArtistBio = "ArtistBio",
  FourImages = "FourImages",
  Other = "Other",
}

export const displayTypeOptions = mapEnumToOptions(DisplayType);
